const state = {
    profitLossItem: null,
    viewBetsItem:null,
    plFilterOption:null
};
const getters = {
    profitLossItem: state => state?.profitLossItem,
    plFilterOption: state => state?.plFilterOption,
    viewBetsItem: state => state?.viewBetsItem,
};
const actions = {
    setProfitLossItem({ commit }, profitLossItem) {
        commit('setProfitLossItem', profitLossItem);
    },
    setPlFilterOption({ commit }, plFilterOption) {
        commit('setPlFilterOption', plFilterOption);
    },
    setViewBetsItem({ commit }, viewBetsItem) {
        commit('setViewBetsItem', viewBetsItem);
    },
};
const mutations = {
    setProfitLossItem(state, profitLossItem) {
        state.profitLossItem = profitLossItem;
    },
    setPlFilterOption(state, plFilterOption) {
        state.plFilterOption = plFilterOption;
    },
    setViewBetsItem(state, viewBetsItem) {
        state.viewBetsItem = viewBetsItem;
    },
};
export default {
    state,
    getters,
    actions,
    mutations
};